<template>
    <div id="resumenCompra" :class="{ boxed: boxed }">

        <b-row>

            <b-col lg="6" md="12">
                <b-card title="Detalles de contratación" class="mb-3">
                    <p><strong>Formato de entrega:</strong>
                        {{ contrataYa.deliveryFormat === 'virtual' ? 'eSIM' : 'SIM (Chip)' }}
                    </p>
                    <p v-if="contrataYa.deliveryFormat === 'virtual' && contrataYa.deviceCompatibilityConfirmed">
                        <strong>Compatibilidad del dispositivo confirmada</strong>
                    </p>
                </b-card>
                <b-card title="Configuración de compra" class="mb-3" variant="info">
                    <p>
                        <strong>Tipo de Compra:</strong>
                        {{
                            contrataYa.purchaseType === 'portability' ? 'Portabilidad' :
                                contrataYa.purchaseType === 'newLine' ? 'Nueva Línea' :
                                    contrataYa.purchaseType === 'nirChange' ? 'Cambio de NIR' :
                                        'Desconocido'
                        }}
                    </p>

                    <template v-if="contrataYa.purchaseType === 'portability'">
                        <p><strong>Número a Portar:</strong> {{ contrataYa.numberToPort }}</p>
                        <p><strong>NIP:</strong> {{ contrataYa.nip }}</p>
                    </template>

                    <template v-else-if="contrataYa.purchaseType === 'newLine'">
                        <p><strong>DESEO NUEVO NÚMERO.</strong></p>
                    </template>

                </b-card>
            </b-col>

            <b-col lg="6" md="12">

                <b-card title="Paquete seleccionado" class="mb-3">
                    <public-offer :offer-id="contrataYa.selectedOffer" line-mode />
                    <hr>
                    <p>
                        <strong>Número de líneas:</strong> 
                        {{ contrataYa.numberOfLines }}
                    </p>
                    <p class="r-c-total"><strong>Total:</strong> {{ parseFloat(contrataYa.pu) *
                        parseInt(contrataYa.numberOfLines) | currency }}</p>
                </b-card>

            </b-col>

        </b-row>

        <b-row v-if="contrataYa.deliveryFormat === 'physical'">
            <b-col>
                <b-card title="Dirección de Envío" class="mb-3">
                    <p><strong>Calle:</strong> {{ direccionEnvio.street }}</p>
                    <p><strong>Colonia:</strong> {{ direccionEnvio.neighborhood }}</p>
                    <p><strong>Ciudad:</strong> {{ direccionEnvio.city }}</p>
                    <p><strong>Estado:</strong> {{ direccionEnvio.state }}</p>
                    <p><strong>País:</strong> {{ direccionEnvio.country }}</p>
                    <p><strong>Código Postal:</strong> {{ direccionEnvio.postalCode }}</p>
                    <p><strong>Información Adicional:</strong> {{ direccionEnvio.additionalInfo }}</p>
                </b-card>
            </b-col>
        </b-row>

        <!-- <b-row>
            <b-col>
                <b-card title="Resumen de Compra" class="mb-3">
                    <p><strong>Total a Pagar:</strong> {{ contrataYa.total }}</p>
                    <p><strong>Método de Pago:</strong> {{ contrataYa.paymentMethod }}</p>
                    <p><strong>Fecha de Contratación:</strong> {{ contrataYa.contractDate }}</p>
                </b-card>
            </b-col>
        </b-row> -->

        <b-alert variant="black" show>
            <b-form-checkbox v-model="acceptedTyC" name="check-button" :value="true" :unchecked-value="false">
                Acepto los <a href="/tyc" target="_blank">Términos y Condiciones</a>.
            </b-form-checkbox>
        </b-alert>

        <hr>

        <b-alert variant="info" v-if="!acceptedTyC" show>
            Por favor revisa tu orden y acepta los Términos y Cóndiciones antes de continuar.
        </b-alert>

        <pre v-if="debug"><code>{{ contrataYa }}</code></pre>
        <pre v-if="debug"><code>{{ direccionEnvio }}</code></pre>
    </div>
</template>

<script>
import direccionEnvio from './direccionEnvioArchetype';
import contrataYa from './contrataYa';
import publicOffer from './public-offer.vue';
export default {
    name: 'resumenCompra',
    components: { publicOffer },
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        boxed: {
            type: Boolean,
            default: true
        },
        direccionEnvio: {
            type: Object,
            default: () => ({
                ...direccionEnvio.workAddress
            })
        },
        contrataYa: {
            type: Object,
            default: () => ({
                ...contrataYa.workingData
            })
        }
    },
    data: () => {
        return {
            acceptedTyC: false
        }
    },
    methods: {
        isAccepted() {
            console.log('isAccepted', this.acceptedTyC);
            return this.acceptedTyC;
        },
        // Add any methods if needed
    },
    mounted() {
        this.acceptedTyC = false;
    },
}
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

#resumenCompra {
    .r-c-total {
        font-size: 1.8rem;
        font-weight: bold;
        color: $accent;
    }
    &.boxed {
        background-color: $primary-dark;
        padding: 20px;
        border-radius: 8px;
        box-shadow: $shadowy;

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            color: $accent;
        }
    }
}
</style>